/** @jsx  jsx */
import { css } from '@emotion/core';
import { colorsPalette, shadows } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';

export const spacerMargin = css({
  marginTop: 40,
  marginBottom: 24,
  [MediaQueries.mdAndUp]: {
    marginTop: 48,
    marginBottom: 50,
  },
});

export const spacerPadding = css({
  paddingTop: 40,
  paddingBottom: 24,
  [MediaQueries.mdAndUp]: {
    paddingTop: 48,
    paddingBottom: 50,
  },
});

export const heroTitle = css(typography.effra48, {
  fontWeight: fontWeights.medium,
  color: colorsPalette.black,
  marginBottom: 16,
  [MediaQueries.mdAndUp]: {
    marginBottom: 24,
  },
  [MediaQueries.xl]: {
    marginBottom: 32,
  },
});

export const bodyWrapper = css({
  marginBottom: 5,
  [MediaQueries.mdAndUp]: {
    marginBottom: 0,
  },
  [MediaQueries.xl]: {
    display: 'flex',
    marginBottom: 0,
  },
});

export const bodyText = css(typography.effra16, {
  color: colorsPalette.grey60,
  [MediaQueries.mdAndUp]: {
    ...typography.effra18,
  },
});

export const aligner = css({
  [MediaQueries.xl]: {
    alignItems: 'center',
  },
});

export const searchWrapper = css({
  marginTop: 32,
});

export const searchInputContainer = css({
  position: 'relative',
  transition: 'box-shadow 0.3s',
});

export const searchInputContainerFocus = css({
  boxShadow: shadows.shadow40,
});

export const searchInput = css(typography.effra18, {
  border: `1px solid ${colorsPalette.grey20}`,
  borderRadius: 2,
  backgroundColor: colorsPalette.white,
  color: colorsPalette.black,
  lineHeight: 1.67,
  height: 55,
  width: '100%',
  padding: '0 16px',
  position: 'relative',
  zIndex: 2,
  WebkitAppearance: 'none',

  '::-webkit-input-placeholder': {
    color: colorsPalette.black,
  },
  ':-ms-input-placeholder': {
    color: colorsPalette.black,
  },
  '::placeholder': {
    color: colorsPalette.black,
  },

  ':focus': {
    outline: 0,
    borderColor: colorsPalette.white,
  },

  '::-ms-clear': {
    display: 'none',
  },
});

export const searchIconButton = css({
  border: 0,
  backgroundColor: colorsPalette.transparent,
  position: 'absolute',
  right: 2,
  top: 2,
  width: 48,
  height: 51,
  cursor: 'pointer',
  zIndex: 2,
});

export const searchIcon = css({
  fontSize: 16,
  color: colorsPalette.black,
});

export const suggestionsContainer = css({
  position: 'absolute',
  background: colorsPalette.white,
  boxShadow: shadows.shadow40,
  borderRadius: 2,
  zIndex: 1,
  width: '100%',
  transform: 'translateY(1px)',
  padding: '8px 16px 0',
  [MediaQueries.mdAndUp]: {
    paddingBottom: 9,
  },
});

export const suggestion = css(typography.effra18, {
  position: 'relative',
  color: colorsPalette.black,
  lineHeight: 1.67,
  padding: '16px 0',
  cursor: 'pointer',
  paddingLeft: 28,
  '&:not(:last-child)': {
    borderBottom: `1px solid ${colorsPalette.grey10}`,
  },
  [MediaQueries.mdAndUp]: {
    paddingBottom: 6,
  },
});

export const highlightedSuggestion = css({
  outline: `1px solid ${colorsPalette.teal}`,
});

export const suggestionIcon = css({
  position: 'absolute',
  left: 0,
  top: 21,
});

export const animationContainer = css({
  display: 'block',
  position: 'absolute',
  top: 7,
  right: 13,
  zIndex: 2,
});
